import { render, staticRenderFns } from "./paths-saved.vue?vue&type=template&id=25717936&scoped=true&"
import script from "./paths-saved.vue?vue&type=script&lang=js&"
export * from "./paths-saved.vue?vue&type=script&lang=js&"
import style0 from "./paths-saved.vue?vue&type=style&index=0&id=25717936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25717936",
  null
  
)

export default component.exports